import AllProductsTab from './all-products'
import FootwarTab from './footwear'
import ShirtsTab from './shirts'
import PantsTab from './pants'

export const MainTabMan = () => {
  return {
    AllProductsTab,
    FootwarTab,
    ShirtsTab,
    PantsTab
  }
}
